import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { GET_CARD_SUMMARY, GET_DASHBOARD_CONFIGURATION } from '../../../../../store/actions';
import { Col, Container, Row } from 'reactstrap';
import BreadcrumbTrail from '../../../../Common/BreadcrumbTrail';
import ConfigurationCard from './Components/BenefitCardForApproval';
import { Loader } from '../../../../Common';
import ApprovalCard from '../PedingApprovals/Components/ApprovalCard';
import BenefitCardForApproval from './Components/BenefitCardForApproval';

interface RootState {
  GetDashboardConfiguration?: {
    data?: any;
    loading?: boolean;
  };
  GetCardSummary?: {
    data?: any;
    loading?: boolean;
  };
}

const PendingApprovals = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [approvalCards, setApprovalCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [benefitForApprovalCards, setBenefitForApprovalCards] = useState([]);

  const { getDashboardConfiguration, getDashboardConfigurationLoading } = useSelector((state: RootState) => ({
    getDashboardConfiguration: state.GetDashboardConfiguration.data,
    getDashboardConfigurationLoading: state.GetDashboardConfiguration.loading,
  }));

  const { cardData, cardDataLoading } = useSelector((state: RootState) => ({
    cardData: state.GetCardSummary.data,
    cardDataLoading: state.GetCardSummary.loading,
  }));

  useEffect(() => {
    if (getDashboardConfiguration === null) {
      dispatch({
        type: GET_DASHBOARD_CONFIGURATION,
      });
    }
  }, []);

  useEffect(() => {
    if (getDashboardConfigurationLoading || cardDataLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [getDashboardConfigurationLoading, cardDataLoading]);

  useEffect(() => {
    if (getDashboardConfiguration !== null) {
      const rawVisibleCards = getDashboardConfiguration?.modules?.saved_configuration?.sections
        ?.filter((data: any) => data?.defaultVisibility === true)
        ?.flatMap((section: any) => section?.cards || []);

      setApprovalCards(rawVisibleCards);

      dispatch({
        type: GET_CARD_SUMMARY,
        payload: {
          cards: rawVisibleCards,
        },
      });
    }
  }, [getDashboardConfiguration]);

  const handleBookingTypeEvent = (item, index) => {
    setSelectedCard(index);
    let benefitApprovalCards = getDashboardConfiguration?.modules?.saved_configuration?.sections?.find(
      section => section?.name === item?.toggleSection,
    );
    setBenefitForApprovalCards(benefitApprovalCards?.cards ?? []);
    if (benefitApprovalCards?.cards?.length > 0) {
      dispatch({
        type: GET_CARD_SUMMARY,
        payload: {
          cards: benefitApprovalCards?.cards,
        },
      });
    }
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        {loading && <Loader />}
        <div className="bredcumb-responsive">
          <BreadcrumbTrail title={'Saved Configuration'} navigationby={() => {}} navigation={['Quick Links', 'Saved Configuration']} />
        </div>

        <div className="approval-container rounded-3 mb-4">
          <p className="fw-semibold p-3 m-0 fs-16">Select Approval Types</p>
          <hr className="approval-divider" />
          <div className="approval-scroll-wrapper px-4 pb-5">
            <Row className="flex-nowrap g-3">
              {approvalCards?.map((card, index) => {
                return (
                  <ApprovalCard
                    item={card}
                    key={index}
                    handleClick={() => handleBookingTypeEvent(card, index)}
                    isSelected={selectedCard === index}
                    cardData={cardData}
                  />
                );
              })}
            </Row>
          </div>
        </div>

        {benefitForApprovalCards?.length > 0 && (
          <div className="approval-container rounded-3">
            <p className="fw-semibold p-3 m-0 fs-16">Select benefit for approval</p>
            <hr className="approval-divider" />
            <div className="approval-scroll-wrapper px-4 pb-5">
              <Row className="flex-nowrap g-3">
                {benefitForApprovalCards?.map((card, index) => {
                  return <BenefitCardForApproval key={index} item={card} cardData={cardData} nextNavigation="approvals_module" />;
                })}
              </Row>
            </div>
          </div>
        )}
      </Container>
    </div>
  );
};

export default PendingApprovals;
